export const clean = function(){
  const language = sessionStorage.getItem('language')
  const constObj = sessionStorage.getItem('const_obj')
  sessionStorage.clear()
  sessionStorage.setItem('language',language)
  sessionStorage.setItem('const_obj',constObj)
}